/**
 * テキストをクリップボードにコピーする（Clipboard API が使えない環境は execCommand で代替）
 */
export function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  const isCopied = document.execCommand('copy')
  document.body.removeChild(textarea)

  return isCopied ? Promise.resolve() : Promise.reject(new Error('execCommand copy failed'))
}
